<template>
  <div class="container">

    <div class="header-container">
      <div class="btn-back" @click="navigateBack"/>
      <div class="title" v-if="!wechat">魔方屋未来样板间预约</div>
<!--      <img class="backToHome" src="@/assets/img/goods_detail/ic_home.png" @click="isInApp ? backMainActivity() : toMyHome()" alt="backHome">-->
      <div class="addr">
        <img class="ic" src="@/assets/img/self_service_room/select_room/door.png" alt/>
        <div class="txt"> <span>{{buildings.buildings_name}}</span> 未来样板间 <span>{{buildings.house_list.length}}</span> 套</div>
      </div>
    </div>

    <div class="content-container">
      <div class="hint">请预约您要参观的样板间（可多选 ）</div>
<!--      <div class="list">
        <div class="item" v-for="(room, index) in buildings.house_list" @click="selectRoom(index)">
          <div class="txt">
            <div class="name">{{room.address_info}}</div>
            <div class="desc">{{room.house_name}} | {{ room.bedroom }} | {{room.proportion}}</div>
          </div>
          <van-checkbox v-model="room.checked">
            <template #icon="props">
              <img class="van-checkbox-ic" :src="props.checked ? activeIcon : inactiveIcon" alt/>
            </template>
          </van-checkbox>
        </div>
      </div>-->
      <div class="list">
        <div class="item" v-for="(room,index) in buildings.house_list" :key="index">
          <div  @click="selectRoom(index)">
            <img class="bg" :src="imgDomain + room.program_image"/>
            <div class="main">
              <div class="name">{{room.address_info}}</div>
              <div>{{ room.house_name }}</div>
              <div>{{ room.bedroom }}</div>
              <div>{{ room.proportion }}</div>
            </div>
          </div>
          <div class="time" v-if="room.date && room.checked" @click="editTime(index)">
            预约时间 {{getTime(room.date)}} <img src="@/assets/img/self_service_room/select_room/edit.png" alt>
          </div>
          <van-checkbox class="select-box" v-model="room.checked">
            <template #icon="props">
              <img class="van-checkbox-ic" :src="props.checked ? activeIcon : inactiveIcon" alt/>
            </template>
          </van-checkbox>
        </div>
      </div>
    </div>

    <div class="bottom">
      <span v-show="!is_skip_select_buildings" @click="navigateTo('selfServiceRoom_selectBuildings')">上一步</span>
      <span :class="{long: is_skip_select_buildings}" @click="confirm">确定</span>
    </div>

    <van-calendar
      ref="calender"
      v-model="showDatePicker"
      color="#FFCC00"
      :default-date="defDate"
      :title="'选择参观日期'"
      :show-confirm="false"
      :min-date="getMinDate()"
      :formatter="formatter"
      @open="openCalender"
      @close="selectedDate"
      @confirm="selectedDate"
    />

    <van-popup v-model="showTimePicker" @click-overlay="selectTime" round position="bottom">
      <van-datetime-picker
        ref="timePicker"
        v-model="time"
        type="time"
        title="选择时间"
        cancel-button-text="关闭"
        :max-hour="23"
        :filter="timeFilter"
        @input="timeInput"
        @confirm="selectTime"
        @close="selectTime"
        @cancel="selectTime"
      />
    </van-popup>

  </div>
</template>

<script>

import store from "@/vuex/store"
import {houseShowAppointment, houseShowGetList} from "@/api/api";
import utils from "@/jslib/utils";

export default {
  name: "SelectRoom",
  data(){
    return{
      wechat: utils.getPlatform().weChat,
      isInApp: utils.getPlatform().mfhApp,
      activeIcon: require('@/assets/img/self_service_room/select_room/checked.png'),
      inactiveIcon: require('@/assets/img/self_service_room/select_room/un_checked.png'),

      buildings: {
        house_list:[]
      },
      buildings_id: '',
      selectedRoomIdArrStr: '',
      is_skip_select_buildings: 0,               // 是否跳过了楼盘选择(只有一个楼盘时)

      showDatePicker: false,
      defDate: this.getMinDate(),
      showTimePicker: false,
      time: undefined,
      MAX_HOUR: 20,                              // 最晚只能预约到晚上8点
      selectedHour: 0,                           // 当前选中的小时

      selectedRoomIndex: undefined,              // 当前选中的房间下标

    }
  },
  created() {

    this.setToken()

    let {buildings_id, is_skip_select_buildings} = this.$route.query
    this.buildings_id = buildings_id
    this.is_skip_select_buildings = +is_skip_select_buildings

    if(store.state.pageParam){
      this.buildings = store.state.pageParam.buildings
      // this.autoSelect()
    }
    if(!this.buildings.house_list.length) this.network().houseShowGetList()

  },
  methods:{

    // 只有一个样板间的时候自动选择/预约
    autoSelect(){
      let {house_list} = this.buildings
      if(house_list.length === 1){

        // 自动选中
        // this.selectRoom(0, true)

        // 直接预约
        // this.network().houseShowAppointment([house_list[0].house_show_id])
      }
    },
    selectRoom(index, isChecked){
      let {house_list} = this.buildings
      let checked = ['', undefined, null].includes(isChecked) ? !house_list[index].checked : isChecked

      this.$set(house_list, index, {...house_list[index], checked})

      checked && this.editTime(index)
    },
    editTime(index){
      this.selectedRoomIndex = index
      this.showDatePicker = true
    },

    // 日期选择组件
    selectedDate(date){
      let index = this.selectedRoomIndex
      let {house_list} = this.buildings

      if(date === undefined){
        if(!house_list[index].date){
          date = new Date(this.getMinDate())
        }else{
          return
        }
      }

      this.time = undefined
      this.showTimePicker = true
      this.$nextTick( () => this.$nextTick (
        () => {
          let timePicker = this.$refs.timePicker
          let picker = timePicker.getPicker()
          if(!picker) return
          picker.setIndexes([0, 0])
          this.time = picker.getColumnValue(0) + ':' + picker.getColumnValue(1)
        }
      ) )

      this.$set(house_list, index, {...house_list[index], date:date.getTime()})

      this.showDatePicker = false

    },
    openCalender(){
      let index = this.selectedRoomIndex
      let {house_list} = this.buildings
      let date = new Date()

      // 超过当天最晚能预约的时间就跳到下一天
      let timestamp = house_list[index].date ||
        ( date.getHours() >= (this.MAX_HOUR || 20) - 2 ? date.setDate(date.getDate()+1) : date.getTime() )

      this.defDate = new Date(timestamp)
    },
    formatter(day){

      let year_ = day.date.getFullYear()
      let month_ = day.date.getMonth() + 1
      let date = day.date.getDate()

      let now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      let today = now.getDate()

      if(year_ === year && month_ === month && date === today) day.text = '今天'

      return day
    },
    getMinDate(){
      let date = new Date()

      // 超过当天最晚能预约的时间就跳到下一天
      let minDate = date.getHours() >= (this.MAX_HOUR || 20) - 2 ? new Date(date.setDate(date.getDate()+1)) : date

      return minDate
    },

    // 时间选择
    selectTime(time){
      let index = this.selectedRoomIndex
      let {house_list} = this.buildings

      let date = new Date(house_list[index].date)

      this.time = this.time || time || this.$refs.timePicker.minHour+':'+this.$refs.timePicker.minMinute

      if(this.time){
        let [hour, minute] = this.time.split(':')
        date.setHours(hour, minute)
      }

      this.$set(house_list, index, {...house_list[index], date: date.getTime()})

      this.showTimePicker = false
    },
    getTime(datestamp){
      let timeStr = utils.getTime(datestamp/1000, 'detail').split(' ')
      return timeStr[0].split('-').join('.') + ' ' + timeStr[1].substring(0, timeStr[1].lastIndexOf(':'))
    },
    timeInput(val){

      console.log(val)
      let [hour, minute] = val.split(':')

      this.selectedHour = +hour
    },
    timeFilter(type, values){

      let MIN_HOUR = 9              // 每天最早只能预约9点30
      let MIN_MINUTE = 30           // 每天最早只能预约9点30
      let MAX_HOUR = 20             // 每天最晚只能预约20点

      let index = this.selectedRoomIndex
      let {house_list} = this.buildings

      let date = new Date()

      date = utils.adjustTime({hour: 2})  // 当天只能选两小时后

      let hour = date.getHours()
      let minute = date.getMinutes()
      let minHour = hour                         // 当前时间
      let minMinute = minute                     // 当前时间

      // 更新时间选择范围后更新当前选择的值
      let updateSelectedTime = ()=>{
        this.$nextTick(()=>{
          let timePicker = this.$refs.timePicker
          let picker = timePicker.getPicker()
          let [hour, minute] = [picker.getColumnValue(0), picker.getColumnValue(1)]
          this.time = hour + ':' + minute
        })
      }

      let appointmentDate = house_list && house_list[index] && house_list[index].date
      let sameDay = utils.getTimeStr(date.getTime(), 'YYYYMMdd') === utils.getTimeStr(appointmentDate,'YYYYMMdd')
      if( !appointmentDate || sameDay ){
        if(hour < MIN_HOUR){
          minHour = MIN_HOUR
          minMinute = MIN_MINUTE
        }
      }else{
        minHour = MIN_HOUR
        minMinute = MIN_MINUTE
      }

      if(type === 'hour'){
        return values.filter(val => val >= minHour && val <= MAX_HOUR)
      }else if(type === 'minute'){
        if(this.selectedHour === MIN_HOUR){
          updateSelectedTime()
          return values.filter(val => val >= MIN_MINUTE)
        }else if(this.selectedHour === minHour){
          updateSelectedTime()
          return values.filter(val => val >= minMinute)
        }else if(this.selectedHour === MAX_HOUR){
          updateSelectedTime()
          return values.filter(val => val == 0)
        }else {
          return values
        }
      }else {
        return values
      }
    },

    confirm(){
      let roomIdArr = []

      this.buildings.house_list.forEach(room => {
        if(room.checked){
          roomIdArr.push(room.house_show_id)
        }
      })

      if(!roomIdArr.length){
        this.$uihelper.toast('请选择房间')
        return
      }

      store.state.pageParam ? store.state.pageParam.buildings = this.buildings : store.state.pageParam = {buildings: this.buildings}
      this.navigateTo('selfServiceRoom_Registration?buildings_id='+this.buildings.buildings_id)
      // this.network().houseShowAppointment(roomIdArr)
    },
    network(){
      return{
        houseShowAppointment: async (house_show_ids=[]) => {

          house_show_ids = house_show_ids.join(',')
          this.selectedRoomIdArrStr = house_show_ids

          let {data} = await houseShowAppointment({house_show_ids})
          console.log('预约结果', data)

          let {code, message} = data
          if(code == 200){
            this.handler().houseShowAppointment(data.data)
          }else {
            this.$uihelper.toast(message)
          }

        },
        houseShowGetList: async () => {
          let {data} = await houseShowGetList()
          console.log('获取可预约房间信息', data)

          let {code, message} = data
          if(code == 200){
            this.handler().houseShowGetList(data.data)
          }else {
            this.$uihelper.toast(message)
          }
        }
      }
    },
    handler(){
      return{
        houseShowAppointment: (data) => {

          this.$uihelper.toast('预约成功')

          setTimeout(()=>{
            this.navigateTo('selfServiceRoom_Booked?buildings_id='+this.buildings_id+'&room_arr_str='+this.selectedRoomIdArrStr)
          }, 300)

        },
        houseShowGetList: (data) => {
          if(data){
            let buildingsList = data.list || []
            for(let i in buildingsList){
              if(buildingsList[i].buildings_id == this.buildings_id){
                this.buildings = buildingsList[i]
                break
              }
            }
            // this.autoSelect()
          }else{
            console.log('未获取到可预约房间信息')
            this.$uihelper.toast('未获取到可预约房间信息')
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "SelectRoom";
</style>
